import { graphql } from 'react-relay';

import { ProblemGeneratorWindowPaginator_query$key } from '../../../relay/__generated__/ProblemGeneratorWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const ProblemGeneratorWindowPaginator_query = graphql`
  fragment ProblemGeneratorWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: ProblemGeneratorFilter }
    order: { type: ProblemGeneratorOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int }
  )
  @refetchable(queryName: "ProblemGeneratorWindowPaginatorRefreshQuery") {
    problemGenerators(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
          status
        }
      }
      ...ProblemGeneratorConnectionDataTable_problemGeneratorConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<ProblemGeneratorWindowPaginator_query$key>, 'fragment'>;

const ProblemGeneratorWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={ProblemGeneratorWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination pages={data.problemGenerators.pages} loadPage={loadPage} {...props} />,
      })
    }
  </FragmentWindowPaginator>
);

export default ProblemGeneratorWindowPaginator;
